import { ValidationErrors, FormGroup } from "@angular/forms";

export function confirmPasswordMatchValidator(passwordKey: string, confirmPasswordKey: string, groupKey: string = "ConfirmPassword"): (g: FormGroup) => ValidationErrors | null {
    return (g: FormGroup) => {
        const passwordValue = g.get(passwordKey).value;
        const confirmPasswordValue = g.get(confirmPasswordKey).value;

        if (!passwordValue || !confirmPasswordValue) {
            return null;
        }

        if (passwordValue != confirmPasswordValue) {
            const error = {};
            error[groupKey] = { MisMatch: true };
            return error;
        }

        return null;
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/password/confirm-password-match-validator.ts